import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, provideHttpClient } from '@angular/common/http';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { RouteReusableStrategy } from './route-reusable-strategy';
import { HttpService } from './http/http.service';
import { ApiService } from './api-service/api.service';
import { SharedModule } from '@app/shared/shared.module';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';

@NgModule({
  imports: [CommonModule, TranslateModule, RouterModule, SharedModule],
  providers: [
    provideHttpClient(),
    {
      provide: HttpClient,
      useClass: HttpService
    },
    {
      provide: RouteReuseStrategy,
      useClass: RouteReusableStrategy
    },
    ApiService
    // { provide: MAT_DATE_LOCALE, useValue: 'ar' },
    //  { provide: DateAdapter, useClass: EnglishDateAdapter }, // Value English
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    // Import guard
    if (parentModule) {
      throw new Error(`${parentModule} has already been loaded. Import Core module in the AppModule only.`);
    }
  }
}
